<template>
    <div class="content-container page-not-found-container">
        <img style="max-width: 400px" :src="NotFoundSVG" alt="not found image" />
        <h4 class="page-not-found-text">
            {{ $t("shared.The specified URL doesnt exist or you arent authorized to access this page") }}
        </h4>
        <router-link to="/" class="router-link">
            <QitButton data-qs="return-to-home-button" :label="$t('shared.Return to Home')" />
        </router-link>
    </div>
</template>

<script setup lang="ts">
import NotFoundSVG from "../assets/images/404.svg?url";
import QitButton from "@/shared/components/buttons/qit-button.vue";
import { onMounted } from "vue";
import { useMatomo } from "@/shared/analytics/matomo.ts";

const { track404 } = useMatomo();

onMounted(() => {
    track404();
});
</script>

<style lang="scss" scoped>
.page-not-found-container {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}

.page-not-found-text {
    padding: 0 $spacing-xl;
    text-align: center;
}
</style>
